import type React from 'react';
import { Heading } from '@//components/Heading';
import { Logo } from '@//components/Logo';
import styles from './WidgetHeading.module.scss';

interface WidgetHeadingLogotypeProps {
  src: string;
  srcSet?: string;
  alt: string;
}

interface WidgetHeadingProps {
  id?: string;
  children: React.ReactNode;
  logotype?: WidgetHeadingLogotypeProps;
  description?: string;
}

interface WidgetHeadingElementProps {
  id?: string;
  children: React.ReactNode;
}

const WidgetHeadingElement: React.FC<WidgetHeadingElementProps> = ({ id, children }) => (
  <Heading level={3} size="md" id={id}>
    {children}
  </Heading>
);

export const WidgetHeading: React.FC<WidgetHeadingProps> = ({
  id,
  children,
  logotype,
  description,
}) => (
  <header className={styles.header}>
    {description ? (
      <div className={styles.info}>
        <WidgetHeadingElement id={id}>{children}</WidgetHeadingElement>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    ) : (
      <WidgetHeadingElement id={id}>{children}</WidgetHeadingElement>
    )}
    {logotype && (
      <Logo
        src={logotype.src}
        srcSet={logotype.srcSet}
        alt={logotype.alt}
        width={120}
        height={48}
        logoSize="sm"
        align="end"
      />
    )}
  </header>
);
